export default "__VITE_ASSET__CwF4WoBg__"